export const AssetRoutes = {
  INDEX: "/assets",
} as const;
